// Go-Live (Juni 2026) – Rechtliche Pflichtseiten für CLartext, redaktionell
// finalisiert und bereit zur anwaltlichen Endprüfung. WICHTIG: Noch nicht
// anwaltlich freigegeben – Veröffentlichung erst nach finaler Prüfung durch
// Rechtsanwalt/Betreiber. Nur redaktionelle Inhalte – KEINE Änderung an
// App-Logik, APIs, Datenmodellen, Tenant-Isolation, WORM, KI, PDF.
//
// Stammdaten (vom Betreiber bestätigt):
//   LU-Finance Holding GmbH · Wilhelm-Dilich-Straße 6 · 34590 Wabern
//   GF Christian Lumpe · AG Fritzlar HRB 12866 · USt-IdNr. DE367193638
//   Plattform CLartext · clartext.io
//   Kontakt: info@clartext.io · Support: support@clartext.io
//   Datenschutz: datenschutz@clartext.io · Abrechnung: billing@clartext.io
//   System-/Benachrichtigungsabsender: noreply@clartext.io
//
// Offene Punkte für die anwaltliche Prüfung (echte fachliche Entscheidungen,
// daher NICHT redaktionell erfunden): konkrete KI-Anbieter (Datenschutz §6),
// konkrete Drittland-/Verarbeitungsorte (Datenschutz §7), Analyse-/Tracking-
// Dienste (Datenschutz §11), finaler Hosting-Anbieter.
// (Preismodell, Testphase und Kündigungsfristen sind in AGB §6 finalisiert.)

export const LEGAL_PAGES = {
  // ---------------------------------------------------------------- IMPRESSUM
  impressum: {
    intro: "Angaben gemäß § 5 Digitale-Dienste-Gesetz (DDG).",
    sections: [
      {
        h: "Anbieter",
        body: [
          { kv: [
            ["Unternehmen", "LU-Finance Holding GmbH"],
            ["Anschrift", "Wilhelm-Dilich-Straße 6, 34590 Wabern, Deutschland"],
            ["Vertreten durch", "Geschäftsführer Christian Lumpe"],
            ["Handelsregister", "Amtsgericht Fritzlar, HRB 12866"],
            ["USt-IdNr. (§ 27a UStG)", "DE367193638"],
          ] },
        ],
      },
      {
        h: "Kontakt",
        body: [
          { kv: [
            ["E-Mail (allgemein)", "info@clartext.io"],
            ["Support", "support@clartext.io"],
            ["Datenschutz", "datenschutz@clartext.io"],
            ["Telefon", "Derzeit nicht vorgesehen."],
          ] },
        ],
      },
      {
        h: "Verantwortlich für den Inhalt (§ 18 Abs. 2 MStV)",
        body: ["Christian Lumpe, Anschrift wie oben."],
      },
      {
        h: "Plattform",
        body: ["CLartext (clartext.io) – KI-gestützte B2B-Nachweisplattform für Arbeitsschutz, betrieben von der LU-Finance Holding GmbH."],
      },
      {
        h: "Hinweis zur Streitbeilegung",
        body: [
          "Das Angebot richtet sich ausschließlich an Unternehmer im Sinne des § 14 BGB (B2B). Eine Teilnahme an einem Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle ist daher nicht vorgesehen.",
        ],
      },
    ],
  },

  // ------------------------------------------------------------- DATENSCHUTZ
  datenschutz: {
    intro: "Informationen zur Verarbeitung personenbezogener Daten nach Art. 13/14 DSGVO.",
    sections: [
      {
        h: "1. Verantwortlicher",
        body: [
          "LU-Finance Holding GmbH, Wilhelm-Dilich-Straße 6, 34590 Wabern, Deutschland. Vertreten durch Geschäftsführer Christian Lumpe. Allgemeiner Kontakt: info@clartext.io. Datenschutzkontakt: datenschutz@clartext.io.",
        ],
      },
      {
        h: "2. Verarbeitete Daten",
        body: [
          "Im Rahmen der Nutzung von CLartext werden insbesondere verarbeitet:",
          { ul: [
            "Unternehmens-/Bestandsdaten des Kunden (Firmenname, Anschrift, Ansprechpartner, Kontaktdaten)",
            "Konto-/Zugangsdaten (E-Mail-Adresse, Zugangs-PINs in gehashter Form)",
            "Mitarbeiterdaten des Kunden (Name, Einsatzbereich, Unterweisungs-/Nachweisstatus; optional eine vom Mitarbeiter freiwillig hinterlegte E-Mail-Adresse, die ausschließlich für Benachrichtigungen über neue Unterweisungen verwendet wird und jederzeit vom Mitarbeiter selbst entfernt werden kann)",
            "Erzeugte Inhalte und Nachweise (Gefährdungsbeurteilungen, Betriebsanweisungen, Unterweisungen, Nachweis-PDFs, Prüfmappe)",
            "Technische Protokoll-/Audit-Daten zur Revisionssicherheit",
          ] },
        ],
      },
      {
        h: "3. Zwecke und Rechtsgrundlagen",
        body: [
          { ul: [
            "Vertragserfüllung / Bereitstellung der Plattform – Art. 6 Abs. 1 lit. b DSGVO",
            "Erfüllung rechtlicher Pflichten im Arbeitsschutz und der Dokumentation – Art. 6 Abs. 1 lit. c DSGVO",
            "Sicherer und stabiler Betrieb, Missbrauchsvermeidung – berechtigtes Interesse, Art. 6 Abs. 1 lit. f DSGVO",
          ] },
        ],
      },
      {
        h: "4. Rolle bei Mitarbeiterdaten (Auftragsverarbeitung)",
        body: [
          "Für die im Auftrag des Kunden verarbeiteten Mitarbeiter- und Nachweisdaten ist der Kunde (Unternehmer) Verantwortlicher; die LU-Finance Holding GmbH handelt insoweit als Auftragsverarbeiter. Einzelheiten regelt der Auftragsverarbeitungsvertrag (AVV).",
        ],
      },
      {
        h: "5. Empfänger / Auftragsverarbeiter",
        body: [
          "Zur Erbringung der Leistung werden externe Dienstleister eingesetzt, mit denen Verträge zur Auftragsverarbeitung nach Art. 28 DSGVO geschlossen werden:",
          { ul: [
            "MongoDB Atlas (MongoDB, Inc.) – Datenbank-Hosting",
            "Amazon Web Services (AWS S3) – revisionssichere, unveränderliche Dokumentenarchivierung (WORM), Region EU (eu-north-1)",
            "Emergent – Hosting/Compute (Plattformbetrieb) und KI-Gateway",
            "Anthropic (USA) – KI-gestützte Inhaltserzeugung und Übersetzung (über das Emergent-KI-Gateway)",
            "Cloudflare – DNS, TLS-Verschlüsselung und Edge-Auslieferung",
            "Google Fonts (USA) – Auslieferung von Webschriften (dabei wird Ihre IP-Adresse an Google übermittelt); Self-Hosting in Vorbereitung",
          ] },
        ],
      },
      {
        h: "6. KI-gestützte Verarbeitung",
        body: [
          "Zur Erzeugung und Übersetzung von Dokumentationsinhalten, Unterweisungen und Nachweisen werden Fachthemen-/Kurstexte an einen KI-Dienst übermittelt und dort verarbeitet. Dabei werden keine Mitarbeiter-Stammdaten oder PINs an die KI übermittelt (Datenminimierung). Eingesetzter Dienst: Anthropic (USA) über das Emergent-KI-Gateway. Bitte geben Sie in frei beschreibbaren Eingabefeldern keine nicht erforderlichen personenbezogenen Daten ein.",
        ],
      },
      {
        h: "7. Drittlandübermittlung",
        body: [
          "Übermittlungen in die USA (KI-Dienst Anthropic; Google Fonts) erfolgen auf Grundlage geeigneter Garantien (insbesondere EU-Standardvertragsklauseln). Der revisionssichere Nachweisspeicher (AWS S3) liegt in der EU (eu-north-1). Die Region des Datenbank-Hostings (MongoDB Atlas) wird im Rahmen der Auftragsverarbeitung festgelegt bzw. bestätigt.",
        ],
      },
      {
        h: "8. Speicherdauer",
        body: [
          "Nachweise und zugehörige PDF-Dokumente werden revisionssicher (WORM) und entsprechend den gesetzlichen Aufbewahrungspflichten gespeichert. Konto- und Vertragsdaten werden für die Dauer des Vertragsverhältnisses und darüber hinaus im Rahmen gesetzlicher Aufbewahrungsfristen aufbewahrt.",
        ],
      },
      {
        h: "9. Betroffenenrechte",
        body: [
          "Betroffene Personen haben das Recht auf Auskunft (Art. 15), Berichtigung (Art. 16), Löschung (Art. 17), Einschränkung der Verarbeitung (Art. 18), Datenübertragbarkeit (Art. 20) und Widerspruch (Art. 21). Zur Ausübung dieser Rechte gegenüber der LU-Finance Holding GmbH wenden Sie sich an datenschutz@clartext.io. Rechte bezüglich im Auftrag verarbeiteter Mitarbeiterdaten sind gegenüber dem jeweiligen Arbeitgeber (Kunden) geltend zu machen.",
        ],
      },
      {
        h: "10. Beschwerderecht",
        body: [
          "Es besteht ein Beschwerderecht bei einer Datenschutz-Aufsichtsbehörde, insbesondere beim Hessischen Beauftragten für Datenschutz und Informationsfreiheit.",
        ],
      },
      {
        h: "11. Reichweitenmessung / Tracking",
        body: [
          "Es findet kein Tracking statt, und es werden keine Werbe-Cookies gesetzt.",
        ],
      },
    ],
  },

  // --------------------------------------------------------------------- AGB
  agb: {
    intro: "Allgemeine Geschäftsbedingungen für die Nutzung der Plattform CLartext.",
    sections: [
      {
        h: "§ 1 Geltungsbereich, ausschließlich B2B",
        body: [
          "Diese Bedingungen gelten für die Nutzung von CLartext durch Unternehmer im Sinne des § 14 BGB. Das Angebot richtet sich ausschließlich an Unternehmen; ein Vertragsschluss mit Verbrauchern ist ausgeschlossen.",
        ],
      },
      {
        h: "§ 2 Leistungsgegenstand",
        body: [
          "CLartext ist eine cloudbasierte Software (SaaS) zur KI-gestützten Erstellung und Verwaltung von Gefährdungsbeurteilungen, Betriebsanweisungen und Unterweisungen sowie zur Mitarbeiterverwaltung, Zuweisung von Unterweisungen, Nachweiserstellung, Prüfmappe, PDF-Export und revisionssicherer WORM-Archivierung.",
        ],
      },
      {
        h: "§ 3 Verantwortung für Inhalte / kein Beratungsersatz",
        body: [
          "CLartext unterstützt und automatisiert Arbeitsschutzprozesse, ersetzt jedoch keine rechtliche, arbeitsmedizinische oder sicherheitstechnische Beratung (z. B. durch Fachkraft für Arbeitssicherheit oder Betriebsarzt).",
          "Der Kunde bleibt allein verantwortlich für die fachliche und rechtliche Prüfung sowie die Freigabe KI-generierter Inhalte vor deren Verwendung. KI-generierte Vorschläge sind vor der Freigabe auf Richtigkeit und Vollständigkeit zu prüfen.",
          "Inhalte werden auf Wunsch KI-gestützt in weitere Sprachen übersetzt. Maßgeblich und rechtlich verbindlich ist stets die deutschsprachige Fassung. KI-gestützte Übersetzungen können inhaltliche oder sprachliche Fehler enthalten; eine Haftung für Übersetzungsfehler wird im Rahmen von § 7 ausgeschlossen. Der Kunde bleibt verantwortlich, auch übersetzte Inhalte vor deren Verwendung auf Richtigkeit und Eignung zu prüfen und freizugeben.",
        ],
      },
      {
        h: "§ 4 Pflichten des Kunden",
        body: [
          { ul: [
            "Angabe zutreffender Daten und Pflege der Stammdaten",
            "Vertrauliche Behandlung der Zugangsdaten/PINs",
            "Rechtmäßige Nutzung der Plattform und der erzeugten Inhalte",
            "Eigenverantwortliche Prüfung/Freigabe der Dokumente und Nachweise",
          ] },
        ],
      },
      {
        h: "§ 5 Verfügbarkeit",
        body: [
          "Der Anbieter bemüht sich um eine hohe Verfügbarkeit der Plattform. Wartungsarbeiten und Störungen können zu vorübergehenden Einschränkungen führen; eine ununterbrochene Verfügbarkeit wird nicht geschuldet.",
        ],
      },
      {
        h: "§ 6 Preise, Abrechnung, Testphase, Laufzeit und Kündigung",
        body: [
          "(1) Preise. CLartext wird im Abonnement bereitgestellt. Die Vergütung richtet sich nach der Anzahl der aktiven (nicht archivierten) Mitarbeiter im Konto des Kunden sowie nach gebuchten Zusatzmodulen und Zusatzleistungen. Es gelten die zum Zeitpunkt der Bestellung auf clartext.io und im Bestellvorgang ausgewiesenen Preise. Alle Preise verstehen sich netto in Euro zuzüglich der gesetzlichen Umsatzsteuer und gelten ausschließlich gegenüber Unternehmern im Sinne des § 1 dieser Bedingungen.",
          // AGB-P6, Betreiberfreigabe 22.10.
          "(2) Abrechnung und Fälligkeit. Die Abrechnung erfolgt monatlich. Der Abrechnungsmonat beginnt mit dem Tag des Vertragsbeginns. Die Vergütung für die zu Beginn eines Abrechnungsmonats erfassten Mitarbeiter und gebuchten Zusatzmodule ist jeweils im Voraus fällig. Kommen im laufenden Abrechnungsmonat abrechnungsrelevante Einheiten hinzu (insbesondere neu angelegte oder reaktivierte Mitarbeiter sowie Einheiten gebuchter Zusatzmodule), wird für jede hinzugekommene Einheit der volle Monatsbetrag des laufenden Abrechnungsmonats berechnet und mit der nächsten Monatsrechnung eingezogen; eine anteilige Berechnung erfolgt nicht. Dieselbe Einheit wird je Abrechnungsmonat höchstens einmal berechnet. Verringert sich die Zahl der Einheiten, gilt die geringere Zahl ab dem nächsten Abrechnungsmonat; eine Gutschrift für den laufenden Abrechnungsmonat erfolgt nicht.",
          "(3) Kostenlose Testphase. Neue Konten können CLartext 14 Tage kostenlos und unverbindlich testen. Die Testphase beginnt mit der Anlage des Testkontos. Es entsteht keine automatische Zahlungspflicht; ohne aktiven Abschluss eines kostenpflichtigen Abonnements geht das Testkonto nicht in ein kostenpflichtiges Abonnement über.",
          "(4) Verhalten nach Ablauf der Testphase. Nach Ablauf der 14 Tage ohne Abschluss eines kostenpflichtigen Abonnements wird das Konto in einen eingeschränkten Modus (Read-only) versetzt: Anmeldung sowie lesender Zugriff auf bereits erstellte Inhalte, Nachweise und die Prüfmappe einschließlich Export bleiben möglich; schreibende Funktionen (insbesondere die Erstellung und Generierung neuer Inhalte, Zuweisungen sowie die Anlage von Mitarbeitern) bleiben gesperrt, bis ein kostenpflichtiges Abonnement abgeschlossen wird.",
          "(5) Vertragsbeginn. Das kostenpflichtige Vertragsverhältnis beginnt mit dem aktiven Abschluss des Abonnements durch den Kunden (Bestätigung der Bestellung). Mit Vertragsbeginn werden die Funktionsbeschränkungen aufgehoben.",
          "(6) Laufzeit, Verlängerung und Kündigung. Das Abonnement hat eine Mindestlaufzeit von zwölf Monaten ab Vertragsbeginn. Es verlängert sich automatisch um jeweils weitere zwölf Monate, sofern es nicht von einer der Parteien mit einer Frist von drei Monaten zum Ende der jeweiligen Laufzeit gekündigt wird. Die Kündigung bedarf der Textform (z. B. E-Mail an billing@clartext.io).",
          // AGB-P6, Betreiberfreigabe 22.10.
          "(7) Zusatzmodule. Zusatzmodule können monatlich hinzugebucht und abbestellt werden. Eine Zubuchung wird sofort wirksam; für den laufenden Abrechnungsmonat wird der volle Monatsbetrag für die zum Zeitpunkt der Zubuchung erfassten Einheiten berechnet und mit der nächsten Monatsrechnung eingezogen. Eine Abbestellung wird zum Ende des laufenden Abrechnungsmonats wirksam.",
          "(8) Kontakt für Abrechnungsfragen. Fragen zu Rechnungen oder Zahlungen richten Sie bitte an billing@clartext.io.",
          "(9) Zusätzliche eigene Welten können als Welten-Paket einmalig erworben werden. Der Preis ergibt sich aus der jeweils aktuellen Preisangabe bei Bestellung. Erworbene Welten-Pakete verfallen nicht, auch nicht bei Ende des Abonnements; ihre Nutzung setzt ein laufendes Abonnement voraus. Eine Erstattung ist ausgeschlossen, soweit gesetzlich zulässig.",
        ],
      },
      {
        h: "§ 7 Haftung",
        body: [
          "Der Anbieter haftet unbeschränkt bei Vorsatz und grober Fahrlässigkeit sowie nach zwingenden gesetzlichen Vorschriften. Bei leicht fahrlässiger Verletzung wesentlicher Vertragspflichten (Kardinalpflichten) ist die Haftung auf den vertragstypischen, vorhersehbaren Schaden begrenzt. Im Übrigen ist die Haftung ausgeschlossen.",
        ],
      },
      {
        h: "§ 8 Datenschutz / Auftragsverarbeitung",
        body: [
          "Einzelheiten der Datenverarbeitung regeln die Datenschutzerklärung und der Auftragsverarbeitungsvertrag (AVV).",
        ],
      },
      {
        h: "§ 9 Schlussbestimmungen",
        body: [
          "Es gilt das Recht der Bundesrepublik Deutschland. Gerichtsstand ist – soweit zulässig – der Sitz des Anbieters. Sollten einzelne Bestimmungen unwirksam sein, bleibt die Wirksamkeit der übrigen Bestimmungen unberührt.",
        ],
      },
    ],
  },

  // --------------------------------------------------------------------- AVV
  avv: {
    intro: "Auftragsverarbeitungsvertrag gemäß Art. 28 DSGVO.",
    sections: [
      {
        h: "1. Parteien",
        body: [
          "Verantwortlicher: der Kunde (Unternehmer), der CLartext nutzt. Auftragsverarbeiter: LU-Finance Holding GmbH (Betreiberin von CLartext). Dieser Rahmen wird mit Vertragsschluss konkretisiert.",
        ],
      },
      {
        h: "2. Gegenstand und Dauer",
        body: [
          "Gegenstand ist die Verarbeitung personenbezogener Daten im Rahmen der Plattformnutzung für die Dauer des Hauptvertrags.",
        ],
      },
      {
        h: "3. Art und Zweck der Verarbeitung",
        body: [
          "Speicherung und Verarbeitung von Mitarbeiter- und Nachweisdaten zur Erstellung, Zuweisung und revisionssicheren Dokumentation von Arbeitsschutz-Unterweisungen und Nachweisen.",
        ],
      },
      {
        h: "4. Kategorien betroffener Personen und Daten",
        body: [
          { ul: [
            "Betroffene: Mitarbeiter des Unternehmers (Verantwortlicher)",
            "Datenkategorien: Vorname, Nachname, optional Foto, Zugangs-PIN (ausschließlich gehasht, kein Klartext), bevorzugte Sprache, Einsatzbereiche, Zuweisungen sowie Unterweisungs-/Nachweisdaten",
          ] },
        ],
      },
      {
        h: "5. Pflichten des Auftragsverarbeiters",
        body: [
          { ul: [
            "Verarbeitung nur auf dokumentierte Weisung des Verantwortlichen",
            "Verpflichtung der Beschäftigten zur Vertraulichkeit",
            "Umsetzung technischer und organisatorischer Maßnahmen (Art. 32 DSGVO, siehe Ziffer 7)",
            "Unterstützung des Verantwortlichen bei Betroffenenrechten und Meldepflichten",
            "Löschung oder Rückgabe der Daten nach Vertragsende – unter Beachtung der WORM-Archivierung und gesetzlicher Aufbewahrungspflichten",
          ] },
        ],
      },
      {
        h: "6. Unterauftragsverarbeiter",
        body: [
          "Der Verantwortliche genehmigt den Einsatz folgender Unterauftragsverarbeiter; über Änderungen wird informiert:",
          { ul: [
            "MongoDB Atlas (MongoDB, Inc.) – Datenbank-Hosting",
            "Amazon Web Services (AWS S3) – WORM-Dokumentenarchiv, Region EU (eu-north-1)",
            "Emergent – Hosting/Compute (Plattformbetrieb) und KI-Gateway",
            "Anthropic (USA) – KI-gestützte Inhaltserzeugung und Übersetzung (über das Emergent-KI-Gateway)",
            "Cloudflare – DNS, TLS und Edge-Auslieferung",
            "Google Fonts (USA) – Auslieferung von Webschriften",
          ] },
        ],
      },
      {
        h: "7. Technische und organisatorische Maßnahmen (TOM)",
        body: [
          { ul: [
            "Mandantentrennung (strikte Tenant-Isolation der Datenhaltung)",
            "Zugriffskontrolle: PIN-gestützte Owner- und Mitarbeiterzugänge (kein E-Mail/Passwort-Login); PINs werden ausschließlich gehasht gespeichert (bcrypt mit serverseitigem Pepper)",
            "Verschlüsselung: Transportverschlüsselung (TLS) und serverseitige Speicherverschlüsselung (SSE)",
            "Revisionssicherheit: unveränderliche WORM-Archivierung der Nachweis-PDFs",
            "Protokollierung: Audit-Logging sicherheitsrelevanter Vorgänge",
            "Verfügbarkeit/Wiederherstellung: Backups und definierte Wiederherstellungsprozesse",
          ] },
        ],
      },
      {
        h: "8. Kontrollrechte",
        body: [
          "Der Verantwortliche kann sich von der Einhaltung der vereinbarten Maßnahmen in angemessenem Rahmen überzeugen.",
        ],
      },
    ],
  },
};

